import { useQuery } from '@tanstack/react-query';

import { SkyMapAxiosServiceFactory } from '../../../../../services/axios/skymap-axios-service-factory';
import { getHttpStatusCode } from '../../../../api/error-handling';

const useFetchSharedView = (projectId: string) =>
  useQuery({
    queryKey: ['fetch-shared-view', projectId],
    gcTime: 0, // Fetch each time (no cache).
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      try {
        const { data } = await SkyMapAxiosServiceFactory.instance
          .createProjectServiceV0()
          .getSharedView(
            {
              path: {
                projectId,
              },
            },
            signal,
          );
        return data;
      } catch (err) {
        if (getHttpStatusCode(err) === 404) {
          return null;
        }

        throw err;
      }
    },
  });

export { useFetchSharedView };
